import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { Button, Loading } from "@onegovbugs/onegov-react-components";
import styles from "./feeBreakdown.module.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveApplication, calculateFees, calculateOperatorFees, initPayment, initOperatorPayment } from "../../redux/actions";
import { withRouter } from "react-router-dom";
import {
  getApplicationFeeStructure
} from "../../redux/actions";
import { RedirectIfCaptchaNotSelected, RedirectIfPrerequisitesNotSelected } from "../../utils/redirect";
import ScrollToTop from "../../utils/scrollToTop";
import { formatMoney } from '../../utils/FormatHelper';
import { TATTOO_OPERATOR_FORM } from "../../constants";

const FeeBreakdown = props => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfPrerequisitesNotSelected(props);

  ScrollToTop();

  const payment = useSelector((state) => state.payment);

  const dispatch = useDispatch();

  const fees = useSelector(state => state.fees);
  const form = useSelector(state => state.form);
  const application = useSelector(state => state.application);
  const { applicationNo } = application;

  const [totalDue, setTotalDue] = useState(0);
  const [gstAmount, setGstAmount] = useState(0);
  const { feesData, feesLoading, feesFailed, feesSucceeded } = fees;
  const [toggleFeeBreakdown, setToggleFeeBreakdown] = useState(true);
  const { paymentReference, paymentRedirectUrl, loading } = payment;

  //dispatch(calculateFees());

  useEffect(
    () => {
      if (form && form.form === 'operator') {
        dispatch(calculateOperatorFees());
      } else {
        dispatch(calculateFees());
      }

    },
    [dispatch]
  );

  useEffect(
    () => {
      if (form && form.form === 'operator') {
        dispatch(calculateOperatorFees());
      } else {
        dispatch(calculateFees());
      }

    },
    [applicationNo]
  );

  useEffect(() => {
    if (paymentReference && paymentRedirectUrl) {
      window.location.href = `${paymentRedirectUrl}${paymentReference}`;
    }
  }, [paymentReference, paymentRedirectUrl]);

  useEffect(
    () => {
      if (feesData != null && feesData.length > 0) {
        setTotalDue(
          feesData.reduce((total, fc) => total + fc.details.feeAmount, 0)
        );
        setGstAmount(
          feesData.reduce((total, fc) => total + fc.details.gstAmount, 0)
        );
      }
    },
    [feesData, feesLoading, feesFailed, feesSucceeded]
  );

  const submit = () => {
    if (form && form.form === 'operator') {
      dispatch(initOperatorPayment());
    } else {
      dispatch(initPayment());
    }
  };

  const feesBreakdown = (
    <ul className={styles.tableColumnsHorizontal}>
      {feesData &&
        feesData.map(
          (el, i) =>
            el.details.feeAmount > 0 && (
              <li key={"feeBreakdown-" + i}>
                <p>{el.label}</p>
                <h4>{formatMoney(el.details.feeAmount, 2, '.', ',', '$')}</h4>
              </li>
            )
        )}

      <li className={styles.total} key="totalFee">
        <p>Total</p>
        <h4>{formatMoney(totalDue, 2, '.', ',', '$')}</h4>
        {/*<h4>${totalDue + gstAmount}</h4>*/}
      </li>
    </ul>
  );

  return (
    <div className={styles.mainCont}>
      {feesSucceeded == true && feesLoading == false ? (
        <div className={`row`}>
          <div className={`col-lg-12`}>
            <div>
              <div className={styles.paymentPart}>
                <div>
                  <div className={styles.upperContainer}>
                    <p>Total Due</p>
                    <h2 className={styles.totalDue}>{formatMoney(totalDue, 2, '.', ',', '$')}</h2>
                  </div>
                  {totalDue != 0 && (
                    <div>
                      <hr />
                      <div className={styles.bottomContainer}>
                        <h3
                          className={styles.toggleFeeBreakdown}
                          onClick={() => {
                            setToggleFeeBreakdown(!toggleFeeBreakdown);
                          }}
                        >
                          {!toggleFeeBreakdown ? "Hide" : "Show"} fee breakdown{" "}
                          <ExpandLessIcon
                            className={
                              toggleFeeBreakdown ? styles.collapse : ""
                            }
                          />
                        </h3>
                        <div
                          className={[
                            styles.feeBreakdown,
                            !toggleFeeBreakdown ? styles.show : styles.hide
                          ].join(" ")}
                        >
                          {feesBreakdown}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className={`row`}>
                <div className={`col-lg-12 col-xs-6`}>
                  {totalDue != 0 ? (
                    <p className={styles.paymentDescritption}>
                      You will be redirected to a secure Service NSW page for
                      payment when you click on the{" "}
                      <strong>'Proceed to payment'</strong> button.
                    </p>
                  ) : (
                      <p className={styles.paymentDescritption}>
                        As part of the NSW Government’s COVID-19 economic stimulus
                        package, we have waived the new application and renewal
                        fee for the minimum renewal term or discounted fees by 1
                        year.
                      </p>
                    )}
                  <div className={`row ` + styles.topMargin128}>
                    <div className={`col-lg-12 col-xs-6`}>
                      <Button
                        className={styles.buttonPayment}
                        onClick={() => {
                          submit();
                        }}
                      >
                        {totalDue != 0 ? "Proceed to payment" : "Proceed"}
                      </Button>
                      <Button
                        secondary
                        onClick={() => {
                          dispatch(
                            saveApplication("step9", () => {
                              {
                                form.form === TATTOO_OPERATOR_FORM ?
                                  props.history.push(`/operator/dashboard`) :
                                  window.location.href = `${process.env.REACT_APP_BAU_URL}`
                              }
                            })
                          );
                        }}
                      >
                        Save & exit section
                      </Button>
                      <Loading
                        className={styles.processing + " " + styles.hide}
                        label={false}
                        type={"ajax"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
          <Loading
            className={styles.processing + " " + styles.show}
            label={false}
            type={"ajax"}
          />
        )}
    </div>
  );
};

export default withRouter(props => <FeeBreakdown {...props} />);
